import api2 from './api-v2';

const get = async (filter) => {
    const client = await api2.getClient();
    const response = await client.get('deployment-applications', { params: filter });
    return api2.handleSuccess(response);
};

const getById = async ({ id }) => {
    const client = await api2.getClient();
    const app = await client.get(`deployment-applications/${id}`);
    return api2.handleSuccess(app);
};

const validate = async ({ payload }) => {
    const client = await api2.getClient();
    const response = await client.post('deployment-applications/validate', payload);
    return api2.handleSuccess(response);
};

const create = async ({ payload }) => {
    const client = await api2.getClient();
    const response = await client.post('deployment-applications', payload);
    return api2.handleSuccess(response);
};

const update = async (id, { payload }) => {
    const client = await api2.getClient();
    const response = await client.put(`deployment-applications/${id}`, payload);
    return api2.handleSuccess(response);
};

const remove = async (id) => {
    const client = await api2.getClient();
    const response = await client.delete(`deployment-applications/${id}`);
    return api2.handleSuccess(response);
};

export default {
    get,
    getById,
    create,
    update,
    remove,
    validate
};
